<template>
	<div class="search_widget">
		<h3 class="search_header">이 카페 <em class="search_keyword">{{ config.searchKeyword }}</em> 관련글</h3>
		<ul class="search_list">
			<search-item v-for="(article, index) in articles" :key="index" :article="article" :config="config"></search-item>
		</ul>
	</div>
</template>

<script>
import SearchItem from './SearchItem.vue';

export default {
	components: {
		SearchItem
	},
	props: {
		config: Object,
		articles: {
			type: Array,
			default: () => ([])
		}
	}
}
</script>
